unit Web.Json.Utils;

interface

function FormatJobStatsDisplayLine(const AStatsJson: string): string;

implementation

uses
  System.SysUtils,
  JS,
  Web;

function FormatJobStatsDisplayLine(const AStatsJson: string): string;
var
  jsStats: TJSObject;
  jsArray: TJSArray;
  jsItem: TJSObject;

begin
  Result := '';

  if Trim(AStatsJson) = '' then
    Exit;

  try
    jsStats := TJSObject(TJSJSON.parseObject(AStatsJson));
    jsArray := TJSArray(jsStats.Properties['value']);

    if Assigned(jsArray) and (jsArray.Length > 0) then
    begin
      jsItem := TJSObject(jsArray[0]);
      Result := string(jsItem['caption']) + ': ' + string(jsItem['value']);

    end;

  except
    Result := '';

  end;

end;

end.
